<template>
  <div class="modal fade show custom-modal" :class="{'modal-show':showCscPaymentModal}">
    <div class="modal-dailog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="col-12 text-center">
            <div class="row bgc-wrapper">
              <div class="col-12 text-center mt-5">
                <img src="@/assets/images/group-3-copy-3@3x.png" class="done-logo mb-4" alt="done" />
                <p style="font-weight:bold;">Thank you for submitting the details</p>
                <!-- <p>Please login with seperate ID(Checker) to make the payment</p> -->
                <p style="font-weight:bold;"> Your Payment Link is in New Tab</p>
                <button class="bgc-btn-primary mt-5" @click='gotoHome()' id="csc-back-to-home">Back to Home</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "cscPaymentModal",
  props: ["showCscPaymentModal"],
  methods:{
    gotoHome(){
      window.location = this.$store.state.bagic.globalConfiguration.baseUrl ;
    }
  }
};
</script>

<style scoped>
.modal-show {
  display: block;
  transform: scaleY(0) scaleX(0);
  animation: unfoldIn 0.25s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
.custom-modal {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  transform: scale(0);
}
.modal-body {
  overflow: hidden;
}
.modal-content {
  width: 40%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#bancaCheckerModal .modal-dialog {
  max-width: 70%;
}
@keyframes unfoldIn {
  0% {
    transform: scaleY(0.005) scaleX(0);
  }

  50% {
    transform: scaleY(0.005) scaleX(1);
  }

  100% {
    transform: scaleY(1) scaleX(1);
  }
}
</style>